import httpClient from './httpClient'

const get = url => httpClient.get(url)
const post = (url, data) => httpClient.post(url, data)
const put = (url, data) => httpClient.put(url, data)
const remove = url => httpClient.delete(url)

export { get, post, put, remove }
